import Vue from 'vue';
import Router from 'vue-router';


import tool from './routes/tool';
import notice from './routes/notice';
import article from './routes/article';
import survey from './routes/survey';
import robot from './routes/robot';
import setting from './routes/setting';
import workorder from './routes/workorder';
import role from "./routes/role";
import taoke from "./routes/taoke";
import activity from "./routes/activity";


import project from './routes/project';
import user from './routes/user';

// 注册单页

const demo  = () => import('@/pages/demo');
const index = () => import('@/pages/index');
const login = () => import('@/pages/login');
const ding  = () => import("@/pages/ding");

const home = () => import('@/components/home/home');


const error = () => import('@/pages/error/404');
const log = () => import('@/pages/log');


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);

// let basePath = process.env.NODE_ENV=='development' ? '' : '/dist/admin/';
export default new Router({
    // base: basePath,
    mode: 'history',
    routes: [
        {
            path: '/demo',
            component: demo,
            name: 'demo',
        },
        {
            path: '/',
            redirect: '/login',
            name: 'root',
        },
        {
            path: '/login',
            component: login,
            name: 'login',
        },
        {
            path: '/ding',
            component: ding,
            name: 'ding',
        },
        {
            path: "*",
            component: error,
            name: '404',
        },
        {
            path: '/',
            component: home,
            children: [
                {
                    path: '/index',
                    component: index,
                    name: 'index',
                },
                {
                    path: '/log',
                    component: log,
                    name: 'log',
                },
                tool,
                notice,
                article,
                survey,
                robot,
                setting,
                workorder,
                project,
                user,
                role,
                taoke,
                activity
            ]
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js